<template>
  <v-dialog
    v-model="openaiDialogShow"
    max-width="75%"
  >
    <template v-slot:activator="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="buttonType === 'check'"
            class="mx-2"
            :color="buttonClass()"
            :loading="loading"
            v-bind="attrs"
            v-on="on"
            icon
            small
            @click="openDialog"
            :disabled="buttonDisabled"
          >
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-btn
            v-else
            class="mx-2"
            :color="buttonClass()"
            :loading="loading"
            fab
            small
            @click="openDialog"
            :disabled="buttonDisabled"
          >
            <span
              class="font-weight-bold text-white"
              v-bind="attrs"
              v-on="on"
              :style="{color: 'white'}"
            >AI</span>
          </v-btn>
        </template>
        generate AI review
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">OpenAI: {{ poi.name ? poi.name : '' }}</span>
      </v-card-title>

      <v-card-text>
        <div class="py-3">
          <div class="d-flex">
            <h3 class="mb-4">Input</h3>
            <v-spacer></v-spacer>
            <v-btn @click="getDescription" color="primary">
              <span class="pr-2">Go</span>
              <v-icon>mdi-auto-fix</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="py-3">
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Instructions
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="systemPrompt"
                  outlined
                  rows="13"
                  hide-details
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  Reviews
                  <b> {{ getReviewText().length }} char</b>
                  <b class="red--text"> {{ getReviewText().length === 0 ? 'NO REVIEWS' : '' }}</b>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  :value="getReviewText()"
                  label="Reviews"
                  outlined
                  readonly
                  hide-details
                ></v-textarea>
                <div class="d-flex">
                  <v-spacer></v-spacer>
                  <copy-to-clipboard
                    :text="getReviewText()"
                    @copy="setSnack({
                      color: 'green',
                      text: 'copied',
                    });"
                  >
                    <v-btn>Copy</v-btn>
                  </copy-to-clipboard>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <h3 class="mb-4">Output</h3>
        <div v-if="poiData.type === $constants.POI_TYPES.ATTRACTION">
          <h4 class="black--text">
            Headline - sell the attraction like a front page headline
          </h4>
          <div>
            <v-radio-group v-model="radioHeadlines" row>
              <v-container>
                <v-row
                  v-for="(headline, index) in headlines"
                  :key="index"
                  align="center"
                  justify="center"
                  :class="headline.type === 'new' ? 'green accent-1' : ''"
                >
                  <v-col class="flex-grow-1 flex-shrink-0">
                    <v-textarea
                      v-model="headlines[index].text"
                      outlined
                      dense
                      rows="1"
                      :counter="true"
                    ></v-textarea>
                  </v-col>
                  <v-col class="text-center flex-grow-0 flex-shrink-1">
                    <v-radio
                      :value="index"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-container>
            </v-radio-group>
          </div>
        </div>
        <div v-if="poiData.type === $constants.POI_TYPES.ATTRACTION">
          <h4 class="black--text">
            Experience description: - Tell me about this in 100 words.
            Used as a textual and voice description
          </h4>
          <v-radio-group v-model="radioDescriptions" row>
            <v-container>
              <v-row
                v-for="(description, index) in descriptions"
                :key="index"
                align="center"
                justify="center"
                :class="description.type === 'new' ? 'green accent-1' : ''"
              >
                <v-col class="flex-grow-1 flex-shrink-0">
                  <v-textarea
                    v-model="descriptions[index].text"
                    outlined
                    dense
                    :counter="true"
                  ></v-textarea>
                </v-col>
                <v-col class="text-center flex-grow-0 flex-shrink-1">
                  <v-radio
                    :value="index"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-container>
          </v-radio-group>
        </div>
        <h4 class="black--text">
          Highlights - What will I experience overlayed on the video
        </h4>
        <v-container>
          <v-row
            v-for="(highlight, index) in highlights"
            :key="index"
            align="center"
            justify="center"
            :class="highlight.type === 'new' ? 'green accent-1' : ''"
          >
            <v-col class="flex-grow-1 flex-shrink-0">
              <v-text-field
                v-model="highlights[index].text"
                outlined
                dense
                :counter="true"
              ></v-text-field>
            </v-col>
            <v-col class="text-center flex-grow-0 flex-shrink-1">
              <v-checkbox
                v-model="highlights[index].check"
              >
              </v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Raw response
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-textarea
                v-model="row"
                outlined
                hide-details
                dense
              ></v-textarea>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="openaiDialogShow = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="saveData"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import CopyToClipboard from 'vue-copy-to-clipboard';

export default {
  name: 'OpenAi',
  components: {
    CopyToClipboard,
  },
  props: {
    poiData: {
      type: Object,
      default() {
        return {};
      },
    },
    poiId: {
      type: Number,
      default: null,
    },
    triggerRun: {
      type: Number,
      default: 0,
    },
    buttonType: {
      type: String,
      default: 'ai',
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    poi: {},
    openaiDialogShow: false,
    systemPrompt: 'You are an expert travel guide describing {attraction_name} {in_city}. '
      + '{add_prompt} '
      + 'You need to create the following:\n\n'
      + 'Experience description: Create 2 versions. Write one 100-word description and one 75-word description. '
      + 'For each description use an informative, engaging, and positive tone as if you are listening to an expert tour guide. '
      + 'The description needs to start with an opening statement that makes me want to read more,'
      + ' DO NOT begin with the word welcome, DO NOT add HTML tags;\n\n'
      + 'Highlights: 10 attributes of the point of interest in a numbered list format that are 1 to 7 words each, use numbers if appropriate.\n\n',
    withReviewPrompt: 'Use the text below and add additional information as appropriate, but DO NOT create your own facts.',
    withoutReviewPrompt: 'Use common knowledge facts.',
    responseFormat: {
      type: 'json_schema',
      json_schema:
        {
          name: 'content',
          strict: true,
          schema:
            {
              type: 'object',
              properties:
                {
                  experience_description_100_word: { type: 'string' },
                  experience_description_75_word: { type: 'string' },
                  highlights: { type: 'array', items: { type: 'string' } },
                },
              required: ['experience_description_100_word', 'experience_description_75_word', 'highlights'],
              additionalProperties: false,
            },
        },
    },
    radioHeadlines: 0,
    headlines: [],
    radioDescriptions: 0,
    descriptions: [],
    highlights: [],
    row: '',
    loading: false,
  }),

  created() {
    if (Object.keys(this.poiData).length) {
      this.initData(this.poiData);
    }
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    openDialog() {
      if (Object.keys(this.poi).length) {
        this.openaiDialogShow = true;
      } else if (Object.keys(this.poiData).length) {
        this.initData(this.poiData);
      } else {
        this.$requestHelpers
          .get(`api/admin/poi/${this.poiId}`)
          .then((response) => {
            this.initData(response.data);
          });
      }
      this.openaiDialogShow = true;
    },

    initData(data) {
      this.poi = data;
      this.headlines = [];
      if (this.poi.headline) {
        this.headlines.push({ text: this.poi.headline, type: 'old' });
      }
      this.descriptions = [];
      if (this.poi.description) {
        this.descriptions.push({ text: this.poi.description, type: 'old' });
      }
      this.highlights = this.parserList(this.poi.highlights, false).map((item) => ({ text: item.trim(), type: 'old', check: true }));
      this.replacePromptText();
    },

    buttonClass() {
      let buttonClass = 'primary';

      if (this.poiData.type !== this.$constants.POI_TYPES.ATTRACTION) {
        if (
          this.highlights.length
        ) {
          buttonClass = 'green';
        }
      } else if (
        this.headlines.length
        && this.descriptions.length
        && this.highlights.length
      ) {
        buttonClass = 'green';
      }

      if (this.row) {
        buttonClass = 'orange';
      }

      return buttonClass;
    },

    getReviewText() {
      return this.poi.reviews ? this.poi.reviews.map((item) => item?.text).join('\n\n') : '';
    },

    replacePromptText() {
      this.systemPrompt = this.systemPrompt.replaceAll('{attraction_name}', this.poi.name);
      this.systemPrompt = this.systemPrompt.replaceAll('{in_city}', this.poi.city ? `in ${this.poi.city}` : '');

      if (this.getReviewText().length === 0) {
        this.systemPrompt = this.systemPrompt.replaceAll('{add_prompt}', this.withoutReviewPrompt);
      } else {
        this.systemPrompt = this.systemPrompt.replaceAll('{add_prompt}', this.withReviewPrompt);
      }
    },

    parserList(list, remove = true) {
      let listItems = list;
      if (listItems) {
        if (!Array.isArray(listItems)) {
          listItems = listItems.split('\n');
        }
        return listItems.filter((n) => n.trim()).map((item) => {
          if (remove) {
            const regex = /^[-\d•]+.*? /gm;
            return item.trim().replace(regex, '').replace(/^"(.*)"$/, '$1');
          }

          return item.trim();
        });
      }

      return [];
    },

    parserHtmlList(html) {
      const el = document.createElement('html');
      el.innerHTML = html;
      const list = el.getElementsByTagName('li');
      const arrayList = [];
      for (let i = 0; i < list.length; i += 1) {
        arrayList.push(list[i].innerHTML);
      }

      return arrayList;
    },

    getDescription(withOverlay = true) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.$requestHelpers
        .post(
          'api/admin/openai',
          {
            prompt: this.getReviewText().length ? this.getReviewText() : 'Go',
            systemPrompt: this.systemPrompt,
            responseFormat: this.responseFormat,
          },
          {
            withOverlay,
          },
        )
        .then((response) => {
          this.row = JSON.stringify(response.data);

          const description100 = response.data.experience_description_100_word;
          const description75 = response.data.experience_description_75_word;

          this.headlines.push({ text: description100.substring(0, description100.indexOf('. ')).trim(), type: 'new' });
          this.descriptions.push({ text: description100.substring(description100.indexOf('. ') + 1).trim(), type: 'new' });

          this.headlines.push({ text: description75.substring(0, description75.indexOf('. ')).trim(), type: 'new' });
          this.descriptions.push({ text: description75.substring(description75.indexOf('. ') + 1).trim(), type: 'new' });

          this.headlines = this.removeDuplicates(this.headlines);
          this.descriptions = this.removeDuplicates(this.descriptions);

          // get highlights
          const newList = this.parserList(response.data.highlights)
            .map((item) => ({ text: item.trim(), type: 'new', check: false }));
          this.highlights = this.highlights.concat(newList);
          this.highlights = this.removeDuplicates(this.highlights);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveData() {
      let data = {
        headline: this.headlines[this.radioHeadlines]?.text,
        description: this.descriptions[this.radioDescriptions]?.text,
        highlights: this.highlights.length ? this.highlights.filter((e) => e.check).map((item) => item.text).join('\n') : null,
      };

      if (this.poiData.type !== this.$constants.POI_TYPES.ATTRACTION) {
        data = {
          highlights: this.highlights.length ? this.highlights.filter((e) => e.check).map((item) => item.text).join('\n') : null,
        };
      }

      this.$requestHelpers
        .patch(`api/admin/poi/${this.poi.id}`, data)
        .then((response) => {
          if (response.data.success) {
            this.initData(response.data.result);
            this.setSnack({
              color: 'green',
              text: 'saved',
            });
            this.row = '';
            this.openaiDialogShow = false;
            this.$emit('updatePoiData', response.data.result);
          }
        });
    },

    removeDuplicates(arr) {
      const unique = [];
      const newArr = [];
      for (let i = 0; i < arr.length; i += 1) {
        if (unique.indexOf(arr[i].text) === -1) {
          unique.push(arr[i].text);
          newArr.push(arr[i]);
        }
      }
      return newArr;
    },
  },
  watch: {
    triggerRun() {
      this.getDescription(false);
    },
  },
};
</script>
